import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { API, pacienteAuthHeaders, removePacienteToken } from '../../services/pacienteConfig';
import brandIcon from '../../assets/brand/icon.png';
import '../../pages/paciente/PacienteDashboard.css';

const iconProps = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const NAV_ITEMS = [
  {
    id: 'inicio',
    label: 'Inicio',
    path: '/paciente',
    icon: (
      <svg {...iconProps}>
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    id: 'hc',
    label: 'Mi H.C.',
    path: '/paciente/historia-clinica',
    icon: (
      <svg {...iconProps}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    id: 'turnos',
    label: 'Turnos',
    path: '/paciente/turnos',
    icon: (
      <svg {...iconProps}>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    id: 'datos',
    label: 'Perfil',
    path: '/paciente/datos',
    icon: (
      <svg {...iconProps}>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

const logoutIcon = (
  <svg {...iconProps}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export async function pacienteLogout(navigate) {
  try {
    await fetch(`${API}/paciente/logout`, {
      method: 'POST',
      headers: pacienteAuthHeaders(),
    });
  } catch (_e) {
    // ignore network errors on logout
  }
  removePacienteToken();
  localStorage.removeItem('paciente_user');
  navigate('/paciente/login');
}

export function PacienteTabNavigation({ activeTab }) {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleLogout = useCallback(() => {
    pacienteLogout(navigate);
  }, [navigate]);

  const handleTabChange = (item) => {
    navigate(item.path);
  };

  return createPortal(
    <>
      <aside
        className={`paciente-sidebar ${expanded ? 'expanded' : ''}`}
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
      >
        <div className="paciente-sidebar-header">
          <img
            src={brandIcon}
            alt="TurnoOnline"
            className="paciente-sidebar-logo"
          />
          {expanded && <span className="paciente-sidebar-logo-text">Mi Portal</span>}
        </div>

        <nav className="paciente-sidebar-nav" aria-label="Navegacion del portal">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`paciente-sidebar-btn ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => handleTabChange(item)}
              title={item.label}
            >
              <span className="paciente-sidebar-icon">{item.icon}</span>
              {expanded && <span className="paciente-sidebar-label">{item.label}</span>}
            </button>
          ))}
        </nav>

        <button
          type="button"
          className="paciente-sidebar-logout"
          onClick={handleLogout}
          title="Cerrar sesion"
        >
          <span className="paciente-sidebar-icon">{logoutIcon}</span>
          {expanded && <span className="paciente-sidebar-label">Salir</span>}
        </button>
      </aside>

      <nav className="paciente-bottom-tabs" aria-label="Navegacion del portal">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`ptab-btn ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => handleTabChange(item)}
          >
            <span className="ptab-icon">{item.icon}</span>
            <span className="ptab-label">{item.label}</span>
          </button>
        ))}
        <button type="button" className="ptab-btn" onClick={handleLogout}>
          <span className="ptab-icon">{logoutIcon}</span>
          <span className="ptab-label">Salir</span>
        </button>
      </nav>
    </>,
    document.body
  );
}

export default PacienteTabNavigation;
